import "slick-carousel/slick/slick.css";

import { FC, useEffect } from "react";
import { setTitle } from "@store/title-store";
import clsx from "clsx";

import { ErrorModal } from "@modals/modal-items/error/error-modal";
import styles from "@scss/pages/error.module.scss";

type ErrorPagePropsT = {
  className?: string;
};

export const ErrorPage: FC<ErrorPagePropsT> = ({ className }) => {
  useEffect(() => {
    setTitle([
      { title: "Главная", href: "/" },
      { title: "Произошла ошибка", href: "/" },
    ]);
  }, []);

  return (
    <main className={clsx("content-container", styles.error)}>
      <div className="content-section">
        <div className="error-content">
          <ErrorModal open={true} onClose={() => null} />
        </div>
      </div>
    </main>
  );
};
